import React from 'react';
import { observer } from 'mobx-react';
import { linearModel } from 'mobx-store';

import BoxPlot from 'components/BoxPlot';

const BoxPlotComponent = observer(
  class BoxPlotComponent extends React.Component {
    render () {
      return (
        <BoxPlot
          boxes={linearModel.boxPlotData}
          yAxisLabel={linearModel.numericalParameter.name}
          xAxisLabel={linearModel.categoricalParameter.name}
        />
      );
    }
  }
);

export default BoxPlotComponent;
